// services/leaderboard.services.js
import axios from 'axios';
import { createHeaders } from './headerUtils';

const BASE_URL = process.env.REACT_APP_BASE_URL;

/**
 * Service class for interacting with user profile APIs
 */
const leaderboardServices = {
  getActivityLeaderboard: async (startDate, endDate, limit = 20) => {
    try {
      const apiUrl = `${BASE_URL}/leaderboard/profile/activity`;
      const headers = createHeaders();
      const params = {
        startDate,
        endDate,
        limit
      };
      
      const response = await axios.get(apiUrl, { headers, params });
      
      return response.data;
    } catch (error) {
      console.error('Error fetching activity leaderboard:', error);
      throw error;
    }
  },

  getDailyLeaderboard: async () => {
    try {
      const apiUrl = `${BASE_URL}/leaderboard/daily`;
      const headers = createHeaders();
      const response = await axios.get(apiUrl, { headers });
      return response.data;
    } catch (error) {
      console.error('Error fetching daily leaderboard:', error);
      throw error;
    }
  },

  getWeeklyLeaderboard: async () => {
    try {
      const apiUrl = `${BASE_URL}/leaderboard/weekly`;
      const headers = createHeaders();
      const response = await axios.get(apiUrl, { headers });
      return response.data;
    } catch (error) {
      console.error('Error fetching weekly leaderboard:', error);
      throw error;
    }
  },

  getCombinedLeaderboard: async () => {
    try {
      const apiUrl = `${BASE_URL}/leaderboard/leaderboard-data`;
      const headers = createHeaders();
      const response = await axios.get(apiUrl, { headers });
      return response.data;
    } catch (error) {
      console.error('Error fetching combined leaderboard:', error);
      throw error;
    }
  }
};

export default leaderboardServices;
